module.exports = __webpack_public_path__ + "img/img (26).47392894.png";